import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { useDispatch } from 'react-redux';

import { Api } from '../api';
import { AppState } from './models/app-state';

export type ReduxDispatch = ThunkDispatch<AppState, { api: Api }, Action>;

/**
 * @deprecated Use useAppDispatch from ./store.ts
 */
export const useThunkDispatch = (): ReduxDispatch => {
    return useDispatch<ReduxDispatch>();
};
